<template>
  <div class="common-box">
    <el-row class="row-one">
      <span class="row-one-title">支付结果</span>
    </el-row>
    <section class="xDetail">
      <div class="xDetail-icon">
        <img v-if="success" src="../../assets/images/hbb/bigRight_230210309.png" width="40" alt="">
        <img v-else src="../../assets/images/hbb/error_20210309.png" width="40" alt="">
      </div>
      <p v-if="success" class="xDetail-title gColor">支付成功</p>
      <p v-else class="xDetail-title rColor">支付失败</p>
      <hr class="xDetail-hr">
      <ul class="xDetail-ul">
        <li class="xDetail-ul-li"><span>产品名称：</span><span>{{order_name}}</span></li>
        <li class="xDetail-ul-li"><span>支付金额：</span><span>{{order_amt+ '元'}}</span></li>
        <li class="xDetail-ul-li"><span>交易日期：</span><span>{{order_date}}</span></li>
        <!-- <li class="xDetail-ul-li"><span>订单编号：</span><span>{{order_id}}</span></li> -->
      </ul>
      <hr class="xDetail-hr">
      <div class="xDetail-footer">
        <el-button type="back" @click="$router.push({name:'myAssets'})">返回</el-button>
        <el-button v-show="order_name != '点财通会员'" type="normal" @click="$router.push({name:'myDiagnosis',params:{active:'2'}})">我的诊断</el-button>
      </div>
    </section>
  </div>
</template>


<script>
export default {
  data () {
    return {
      order_amt: '--',//金额
      order_date: '--',//时间
      order_id: '--',//订单号
      success: true,
      order_name: ''
    }
  },
  created () {
    let art = window.sessionStorage.getItem('order_amt')
    let id = window.sessionStorage.getItem('order_id')
    let date = window.sessionStorage.getItem('order_date')
    let name = window.sessionStorage.getItem('order_name')
    this.order_amt = art ? art.slice(0, -2) : '--'
    this.order_id = id ? id : '--'
    this.order_date = this.$commonJs.getDateStrHg(date)
    this.order_name = name == '组合基金诊断' ? '啄木鸟基金组合诊断' : '点财通会员'
  },
  mounted () {
    this.getOrder()
  },
  methods: {
    getOrder () {
      this.$http.post(this.$apiPath.queryPc, {//1:退款成功 2：退款处理中，3：退款失败，11支付成功其他均为失败判断一笔订单是否成功，12：已退款，order_st为准
        order_id: this.order_id,//this.order_id
        order_type: "PAY"
      }).then(res => {
        // console.log(res);
        if (res.data.code == "200") {
          let xdata = res.data.data
          if (xdata.order_st == "11") {
            this.success = true
          } else {
            this.success = false
          }
        } else {
          this.success = false
        }
      }).catch(err => { })
    },

  }
}
</script>